module.exports = __webpack_public_path__ + "static/act-871918a58aac5f3b6466b5810adc7789.jpg";